module.exports = __webpack_public_path__ + "55a0f5c1432d556f36145d10f937d2f8.pdf";